/**
 * What the last session probe said, kept across page loads (2026-09-06;
 * owner: "I don't like how there's always that slow checking your session
 * screen whenever I refresh page"). A refresh is not a new visit: when the
 * last probe said you were signed in, the app renders at once and the new
 * probe runs behind it; only an answer of "not signed in" sends you to the
 * login page. Nothing secret lives here, just the one word.
 */

const KEY = 'loremap.auth';

export type RememberedAuth = 'in' | 'out';

export function readRememberedAuth(): RememberedAuth | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === 'in' || value === 'out' ? value : null;
  } catch {
    return null;
  }
}

export function rememberAuth(state: RememberedAuth): void {
  try {
    window.localStorage.setItem(KEY, state);
  } catch {
    // private mode, or storage full: the next load just probes first
  }
}
